import { useWindowSize } from "@uidotdev/usehooks";
import {
  PanelGroup,
  Panel as ResizablePanel,
  PanelResizeHandle,
} from "react-resizable-panels";
import { Saved } from "../Saved";
import { Examples } from "../Examples";
import { Query } from "../Query";
import { Results } from "../Results";
import { Panel } from "./Panel";
import { TabsPanel } from "./TabsPanel";
import { styled } from "@mui/joy";
import { useEffect, useState } from "react";
import { useExplicitQueryContext } from "../../../context/explicitQuery";

export function IndexPagePanels() {
  const { width } = useWindowSize();
  const { explicitQuery } = useExplicitQueryContext()

  const queryTabs = {
    query: {
      label: "Query",
      color: "var(--p-violet-400)",
      jsx: <Query />,
    },
    examples: {
      label: "Examples",
      color: "var(--p-pink-400)",
      jsx: <Examples />,
    },
    saved: {
      label: "Saved",
      color: "var(--p-fuchsia-400)",
      jsx: <Saved />,
    },
  };

  const [selectedQueryTab, setSelectedQueryTab] = useState("query");

  // When the query has changed (e.g. by selecting an example query), switch
  // to the query tab. Depending only on explicitQuery ensures this fires on
  // example selection but not when the user manually switches tabs afterward.
  useEffect(() => {
    if (explicitQuery) {
      setSelectedQueryTab("query")
    }
  }, [explicitQuery])

  const resultsTabs = {
    results: {
      label: "Results",
      color: "var(--p-purple-400)",
      jsx: <Results />,
    },
  };

  if (!width) return null;

  if (width > 700)
    return (
      <WrapperPanelGroup
        autoSaveId="localstorage-panels-horiz"
        direction="horizontal"
      >
        <ResizablePanel defaultSize={50} minSize={10} collapsible={true}>
          <TabsPanel
            tabs={queryTabs}
            selectedTab={selectedQueryTab}
            handleTabSelect={(tabId) => setSelectedQueryTab(tabId)}
          />
        </ResizablePanel>

        <Handle horizontal={"false"} />

        <ResizablePanel defaultSize={50} minSize={10} collapsible={true}>
          <Panel tab={resultsTabs.results} />
        </ResizablePanel>
      </WrapperPanelGroup>
    );

  return (
    <TabsPanel
      tabs={{
        ...queryTabs,
        ...resultsTabs,
      }}
      selectedTab={selectedQueryTab}
      handleTabSelect={(tabId) => setSelectedQueryTab(tabId)}
    />
  );
}

const WrapperPanelGroup = styled(PanelGroup)`
  flex: 1;
  min-height: 0;
`;

interface HandleProps {
  horizontal: string;
}
const Handle = styled(PanelResizeHandle)<HandleProps>`
  align-self: center;
  width: 12px;
  border-radius: 6px;
  height: 64px;
  margin: 0 4px;
  backdrop-filter: blur(2px);
  background-color: #664e96;
  border: 1px solid var(--p-slate-400);
  transition: all 250ms cubic-bezier(0.19, 1, 0.22, 1);

  &[data-resize-handle-active="pointer"],
  &:hover {
    background-color: #664e96;
    border-color: var(--p-slate-500);
    transition: all 250ms cubic-bezier(0.19, 1, 0.22, 1);
  }

  &[data-resize-handle-active="pointer"] {
    height: 96px;
    transition: all 250ms cubic-bezier(0.19, 1, 0.22, 1);
  }

  ${({ horizontal }) =>
    horizontal === "true"
      ? `
    & {
      width: 64px;
      height: 12px;
      margin: 4px 0;
    }

    &[data-resize-handle-active='pointer'] {
      width: 96px;
      height: 12px;
      transition: all 250ms cubic-bezier(0.19, 1, 0.22, 1);
    }
  `
      : ""}
`;
